import { useLocation, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Comments } from '../components/shelves/Comments';
import { AddComment } from '../components/shelves/comments/AddComment';
import { ThreadDetail } from '../components/shelves/ThreadDetail';
import { DirectThreadDetail } from '../components/shelves/DirectThreadDetail';

export function ThreadDetailPage() {
  const location = useLocation();
  const { threadId } = useParams();
  const { status } = useSelector((state) => state.auth);
  const authenticated = status === 'authenticated';

  return (
    <div className="prose mx-auto mt-6 mb-16 rounded-lg px-4 prose-code:break-words prose-pre:overflow-scroll prose-pre:break-words dark:prose-invert md:prose-lg lg:px-6">
      {location.state ? <ThreadDetail /> : <DirectThreadDetail />}
      {authenticated ? <AddComment threadId={threadId} /> : ''}
      <Comments />
    </div>
  );
}
